import * as T from '@/types'

import { CrudResource } from '@/api/resources/api-crud'

const routes : {[key: string] : string} = {
    Index: 'creditor/cases',
    Show: 'creditor/cases/${id}',
}

export class CasesResource extends CrudResource<T.Case> {

    get crudBaseCalls () {
        const api = this.api

        return {
            index (filters?: T.Filters, queryParams?: any) {
                return api.get(routes.Index, { params: { limit: 20, ...filters, ...queryParams }})
            },
            page (pageRoute: string) {
                return api.get(pageRoute)
            },
            show (id : T.EntityId) {
                return api.get(routes.Show.replace('${id}', id))  
            },
            // store (user: T.User) {
            //     return api.post(api.route(Users.Store), user)
            // },
            // update (user: T.User) {
            //     return api.patch(api.route(Users.Update, { id: user.id }), user)
            // },
            // delete (user: T.User) {
            //     return api.delete(api.route(Users.Delete, { id: user.id }))
            // },
            // restore (user: T.User) {
            //     return api.patch(api.route(Users.Restore, { id: user.id }))
            // },
        }
    }

    item (data: any) {
        return data
    }

    items (data: any) {
        return data
    }

    map (data: any) {
        return {
            createdAt: data.createdAt,
            id: data.id,
            identifier: data.identifier,
            files: data.files,
            name: data.name,
            updatedAt: data.updatedAt,
        }
    }
}

export default function (api: T.CreditorDeskApi) {
    return new CasesResource(api)
}
